import React, { useEffect, useState , useRef} from "react"
import { Button, Col, Container, InputGroup, Row } from "reactstrap"
import StatsCard from "../../components/StatsCard"
import "react-loading-skeleton/dist/skeleton.css"
import TotalSales from "components/TotalSales"
import OrderStatus from "components/OrderStatus"

import Top5Dealers from "components/Top5Dealers"
import TopSellingProducts from "components/TopSellingProducts"
import { AiOutlineShopping } from "react-icons/ai"
import { BsPersonVcard, BsPatchQuestion } from "react-icons/bs"
import { MdPendingActions } from "react-icons/md"
import RegionSales from "components/RegionSales"
import StoreSales from "components/StoreSales"
import { getPendingOrderCount, getTotalDealerCount, getTotalInquiryCount, getTotalOrderCount } from "http/dashboard"
import { getUser, isPermission } from "common/utility"
import PlantSales from "components/Common/plantWiseSale"
import Flatpickr from "react-flatpickr";
const AdminDashboard = () => {
  document.title = "Dashboard | Subros"
  const [dashboardItem, setDashboardItem] = useState({})
  const [userRoleName,setUserRoleName]= useState("")
  const flatpickrRef = useRef(null);
  const [filters, setFilters] = useState(null);
  const [filtersOnClick, setFiltersOnClick] = useState(null);

  const [dashboardPermission, setDashboardPermission] = useState({
    stats: false,
    topSellingProducts: false,
    totalSales: false,
    orderStatus: false,
    top5Dealers: false,
    regionSales: false,
    storeSales: false,
    plantSales: false,
  })

  const [cardPermission, seCardPermission] = useState({
    isDealerList: false,
    isOrderList: false,
    isInquiryList: false,
  })

  const getData = async () => {
    let result = {}
    let { data: dealer } = await getTotalDealerCount()
    result.dealer = dealer

    let { data: inquiry } = await getTotalInquiryCount()
    result.inquiry = inquiry

    let { data: totalOrder } = await getTotalOrderCount()
    result.totalOrder = totalOrder

    let { data: pendingOrder } = await getPendingOrderCount()
    result.pendingOrder = pendingOrder

    setDashboardItem(result)
  }
  
  const getFinancialYearDates = () => {
    const today = new Date();
    let startYear, endYear;

    if (today.getMonth() + 1 >= 4) {
      startYear = today.getFullYear();
      endYear = today.getFullYear() + 1;
    } else {
      startYear = today.getFullYear() - 1;
      endYear = today.getFullYear();
    }

    const startDate = new Date(`${startYear}-04-01T00:00:00.000Z`); 
    const endDate = new Date(`${endYear}-03-31T23:59:59.999Z`);
    return [startDate.toISOString(), endDate.toISOString()];
  };

  
  useEffect(() => {
    getData()
    checkPermission()
    fetchData()
    const [startDate, endDate] = getFinancialYearDates();
    setFilters({
      startDate: startDate,
      endDate: endDate
    });
    setFiltersOnClick({
      startDate: startDate,
      endDate: endDate
    });
  }, [])

    const fetchData = async () => {
      try {
        const storedUser = await getUser();
        if (storedUser && storedUser?.roleName) {
          setUserRoleName(storedUser?.roleName);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
     
  const adminNumberData = [
    {
      id: 1,
      label: "Total Dealers",
      value: dashboardItem.dealer,
      color: "info",
      icon: (
        <BsPersonVcard
          className={`me-3 text-info`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: `/${userRoleName}/dealers`,
      isPermission: cardPermission.isDealerList
    },
    {
      id: 2,
      label: "Total Inquiries",
      value: dashboardItem.inquiry,
      color: "success",
      icon: (
        <BsPatchQuestion
          className={`me-3 text-success`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: `/${userRoleName}/inquiry`, //`/${data.roleName}/inquiry`
      isPermission: cardPermission.isInquiryList
    },
    {
      id: 3,
      label: "Total Requested Orders",
      value: dashboardItem.totalOrder,
      color: "warning",
      icon: (
        <AiOutlineShopping
          className={`me-3 text-warning`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: `/${userRoleName}/orders`, //`/${data.roleName}/orders`
      isPermission: cardPermission.isOrderList
    },
    {
      id: 4,
      label: "Pending Orders",
      value: dashboardItem.pendingOrder,
      color: "danger",
      icon: (
        <MdPendingActions
          className={`me-3 text-danger`}
          style={{ fontSize: "24px" }}
        />
      ),
      url: `/${userRoleName}/orders?tab=2`, //`/${data.roleName}/orders?tab=2`
      isPermission: cardPermission.isOrderList
    },
  ]

  const checkPermission = async () => {
    const isStats = await isPermission("stats", "view_permission")
    const isTopSellingProducts = await isPermission("top_selling_products", "view_permission")
    const isTotalSales = await isPermission("total_sales", "view_permission")
    const isOrderStatus = await isPermission("order_status", "view_permission")
    const isTopDealers = await isPermission("top_dealers", "view_permission")
    const isRegionSales = await isPermission("region_wise_sales", "view_permission")
    const isStoreSales = await isPermission("store_wise_sales", "view_permission")
    const isPlantSales = await isPermission("plant_wise_sales", "view_permission")

    const dealerList = await isPermission("dealers", "list_permission")
    const inquiryList = await isPermission("product_inquiry", "list_permission")
    const orderList = await isPermission("orders", "list_permission")

    seCardPermission({
      isDealerList: dealerList,
      isOrderList: orderList,
      isInquiryList: inquiryList,
    })

    setDashboardPermission(
      {
        stats: isStats,
        topSellingProducts: isTopSellingProducts,
        totalSales: isTotalSales,
        orderStatus: isOrderStatus,
        top5Dealers: isTopDealers,
        regionSales: isRegionSales,
        storeSales: isStoreSales,
        plantSales: isPlantSales,
      }
    )
  }

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        startDate: selectedDates[0],
        endDate: selectedDates[1]
      })
    }
  };

  const handleDateFilter = () => {
    if (filters?.startDate && filters?.endDate) {
      setFiltersOnClick(filters);
    }
  };

  return (
    <div>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4
                  style={{ marginLeft: "1.2rem" }}
                  className="mb-sm-0 font-size-18"
                >
                  Dashboard
                </h4>
                <div className="d-flex align-items-center justify-content-start" style={{ marginRight: "1.2rem" }}>
                  <InputGroup style={{ minWidth: '250px' }}>
                    <Flatpickr
                      ref={flatpickrRef}
                      className="form-control"
                      placeholder="Start Date - End Date"
                      options={{
                        mode: 'range',
                        dateFormat: 'd-m-Y',
                      }}
                      value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                      onChange={handleDateChange}
                    />
                    <Button variant="primary"
                      onClick={handleDateFilter}
                      style={{ backgroundColor: "#344fa0", border: "none" }}>
                      Go

                    </Button>
                  </InputGroup>
                </div>
              </div>
            </Col>
          </Row>
          <div className="vertical-scroll">
            <Row className="custom-row m-0">
              {adminNumberData?.map(i => (
                 <Col  key={i.id} md={6} lg={3} className="p-0" >
                  <StatsCard
                    color={i.color}
                    label={i?.label}
                    value={i?.value}
                    url={getUrl(i)}
                    icon={i?.icon}
                  />
                </Col>
              ))}
            </Row>
         

          <Row style={{ marginBottom: "1rem" }} className="ms-1 me-1 mt-2 g-3">
            {dashboardPermission.topSellingProducts && (<Col lg={6} >
              <TopSellingProducts startDate={filtersOnClick?.startDate} endDate={filtersOnClick?.endDate} />
            </Col>
            )}
            {dashboardPermission.totalSales && (<Col lg={6}>
              <TotalSales userType={"admin"} startDate={filtersOnClick?.startDate} endDate={filtersOnClick?.endDate} />
            </Col>)}

            {dashboardPermission.orderStatus && (<Col lg={6}>
              <OrderStatus
                totalOrders={dashboardItem.totalOrder || 0}
                userType={"admin"}
                dataColors='["#EC7063", "#AF7AC5", "#3498DB ","#1ABC9C", "#F1C40F"]'
              />
            </Col>)}

            {dashboardPermission.top5Dealers && (<Col lg={6}>
              <Top5Dealers startDate={filtersOnClick?.startDate} endDate={filtersOnClick?.endDate}/>
            </Col>)}

            {dashboardPermission.regionSales && (<Col lg={6}>
              <RegionSales startDate={filtersOnClick?.startDate} endDate={filtersOnClick?.endDate}/>
            </Col>)}

            {/* {dashboardPermission.storeSales && (
              <Col lg={6}>
                <StoreSales />
              </Col>
            )} */}

            {dashboardPermission.plantSales && (
              <Col lg={6}>
                <PlantSales startDate={filtersOnClick?.startDate} endDate={filtersOnClick?.endDate}/>
              </Col>
            )}
          </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default AdminDashboard

function getUrl(ele) {
  if (ele.isPermission) {
    return ele.url
  }
  return null
}